module.exports = " <div class=main _v-08022b84=\"\"> <sidebar :relationship-sessions=relationshipSessions _v-08022b84=\"\"></sidebar> <div class=body _v-08022b84=\"\"> <router-view :relationship-sessions=relationshipSessions _v-08022b84=\"\"></router-view> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-08022b84!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
 ** module id = 330
 ** module chunks = 2
 **/